import type { InstrumentInstrumentType } from "Infrastructure/ApiZfp/Schema/instrumentInstrumentType";
import type { InstrumentRelation } from "Infrastructure/ApiZfp/Schema/instrumentRelation";

export const NsureSelectionItemType = {
  Portfolio: "portfolio",
  Instrument: "instrument",
} as const;

export type NsureSelectionItemType = (typeof NsureSelectionItemType)[keyof typeof NsureSelectionItemType];

export type StrategyInstrument = {
  id: number;
  name: string | null;
  participationInPercentage: number;
};

export type NsureSelectionPortfolio = {
  readonly type: typeof NsureSelectionItemType.Portfolio;
  readonly id: number | string | null;
  readonly expectedPerformance: number | null;
  readonly name: string | null;
  readonly instrumentType: InstrumentInstrumentType | null;
  readonly strategyInstruments: StrategyInstrument[] | null;
  readonly strategyInstrumentsEvaluation: StrategyInstrument[] | null;
  readonly srri: number | null;
  readonly sri: number | null;
  readonly esg: number | null;
  readonly strategyRiskType: string | null;
};

export type NsureSelectionInstrument = {
  readonly type: typeof NsureSelectionItemType.Instrument;
  readonly id: number;
  readonly expectedPerformance: number | null;
  readonly name: string;
  readonly instrumentType: InstrumentInstrumentType | null;
  readonly strategyInstruments: StrategyInstrument[];
  readonly strategyInstrumentsEvaluation: StrategyInstrument[];
  readonly isin: string | null;
  readonly ticker: string | null;
  readonly esg: number | null;
  readonly minInvestmentHorizon: number | null;
  readonly srri: number | null;
  readonly sri: number | null;
  readonly instrumentRelations: InstrumentRelation[] | null;
};

export type NsureSelectionItem = NsureSelectionPortfolio | NsureSelectionInstrument;

export type NsureSelection = NsureSelectionItem | null;
